(function() {
	'use strict';

	angular.module('quantixApp').controller('PortFolioLevelAlertController',
			PortFolioLevelAlertController);

	PortFolioLevelAlertController.$inject = [ '$scope', '$stateParams',
			'$filter', '$rootScope', '$timeout', 'companyData',
			'$uibModalInstance', 'CompanyIndAlertService', 'AlertService',
			'parentAccess', 'GenericService' ];

	function PortFolioLevelAlertController($scope, $stateParams, $filter,
			$rootScope, $timeout, companyData, $uibModalInstance,
			CompanyIndAlertService, AlertService, parentAccess, GenericService) {

		$scope.flagForPortfolioSub = false;
		$scope.errorCompInfo = false;

		var sectionaccess = {};
		GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess=result;
			if (sectionaccess["Portfolio View.Portfolio Level Alert"] != 'Y') {
				$scope.errorCompInfo = true;
				$scope.flagForPortfolioSub = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
		});
		$scope.getPortFolioAlertDetails = function() {

			var indAlertData = {
				industryId : companyData.industryId,
				isIndustryLevel : companyData.isIndustryLevel,
				portfolioId : companyData.portfolioId,
				isPortfolioLevel : companyData.isPortfolioLevel
			};
			CompanyIndAlertService
					.getPortFolioLevelAlertDetails(indAlertData)
					.then(
							function(data) {
								if (data.length != 0) {
									$scope.portFolioLevelAlertDetails = data[0];

									console
											.log(JSON
													.stringify($scope.portFolioLevelAlertDetails));
								} else {
									$uibModalInstance.dismiss('cancel');
								}

							}, function(errordata) {
							});

		}

		$scope.changeInPortFolioMedianRating = function() {

			if ($scope.portFolioLevelAlertDetails.isMedianRating == 'N') {
				$scope.portFolioLevelAlertDetails.isMedianRatingUpgrade = 'N';
				$scope.portFolioLevelAlertDetails.isMedianRatingDowngrade = 'N';
			} else if ($scope.portFolioLevelAlertDetails.isMedianRating == 'Y') {
				$scope.portFolioLevelAlertDetails.isMedianRatingUpgrade = 'Y';
				$scope.portFolioLevelAlertDetails.isMedianRatingDowngrade = 'N';
			}
		}

		$scope.changeInPortFolioMedianRatingInnerFunction = function() {
			if ($scope.portFolioLevelAlertDetails.isMedianRatingUpgrade == 'Y'
					|| $scope.portFolioLevelAlertDetails.isMedianRatingDowngrade == 'Y') {
				$scope.portFolioLevelAlertDetails.isMedianRating = 'Y';
			} else if ($scope.portFolioLevelAlertDetails.isMedianRating == 'Y'
					&& $scope.portFolioLevelAlertDetails.isMedianRatingUpgrade == 'N'
					&& $scope.portFolioLevelAlertDetails.isMedianRatingDowngrade == 'N') {
				$scope.portFolioLevelAlertDetails.isMedianRating = 'N';
				$scope.portFolioLevelAlertDetails.isMedianRatingDowngrade = 'N';
				$scope.portFolioLevelAlertDetails.isMedianRatingUpgrade = 'N';
			}

		}

		$scope.savePortFolioAlertData = function() {

			CompanyIndAlertService.setPortFolioLevelAlert(
					$scope.portFolioLevelAlertDetails).then(function(result) {

				if (result.isSuccess == 'true') {
					$scope.issuccess = true;
					$scope.error = false;
					$scope.successMessages = result.message;
					parentAccess.setportfolioAlertStatus = true;
					$scope.alertAction = 'Remove Alert';
					$scope.portfolioLevelAlertFlag = false;
				} else {
					$scope.error = true;
					$scope.issuccess = false;
					$scope.errorMessages = result.message;

				}
				$timeout(function() {
					$uibModalInstance.dismiss('cancel');
				}, 1000);

			}, function(response, status, headers, config) {
				$scope.error = true;
				$scope.errorMessages = "Error occured while setting Alert"

				$timeout(function() {
					$uibModalInstance.dismiss('cancel');
				}, 1000);

			});

		}

		$scope.defaultAlertData = function() {
			$scope.portFolioLevelAlertDetails = {
				name : 'PortFolio Alert',
				industryId : companyData.industryId,
				portfolioId : companyData.portfolioId,
				isIndustryLevel : companyData.isIndustryLevel,
				isPortfolioLevel : companyData.isPortfolioLevel,
				isCompanyLevel : companyData.isCompanyLevel,
				isMedianRating : 'Y',
				isMedianRatingUpgrade : 'Y',
				isMedianRatingDowngrade : 'N',

			};

			if ($scope.flagForPortfolioSub) {
				$scope.portFolioLevelAlertDetails.isMedianRating = 'N';
				$scope.portFolioLevelAlertDetails.isMedianRatingUpgrade = 'N';
				$scope.portFolioLevelAlertDetails.isMedianRatingDowngrade = 'N';
			}

		}

		$scope.cancel = function() {
			$uibModalInstance.dismiss('cancel');

		}

		$scope.getPortFolioAlertDetails();

	}
})();